"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const input_1 = __importDefault(require("../input"));
const input_styles_1 = require("../input.styles");
const PasswordInput = (props) => {
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    function changeType() {
        setShowPassword(!showPassword);
    }
    function getPasswordIcon() {
        return showPassword ? (react_1.default.createElement(input_styles_1.ShowPasswordIcon, { onClick: changeType })) : (react_1.default.createElement(input_styles_1.HidePasswordIcon, { onClick: changeType }));
    }
    function rightElem() {
        return props.value ? getPasswordIcon() : null;
    }
    return (react_1.default.createElement(input_1.default, Object.assign({}, props, { type: showPassword ? 'text' : 'password', rightElement: rightElem() })));
};
exports.default = PasswordInput;
//# sourceMappingURL=password.js.map